import HomeOne from "./HomeOne";
import AboutUs from "./AboutUs";
import FinancialService from "./FinancialService";
import IncrementService from "./IncrementService";
import ITService from "./ITService";
import JoinUs from "./JoinUs";
import JoinUsStep from "./JoinUsStep";
import JoinUsStep1 from "./JoinUsStep1";
import JoinUsStep2 from "./JoinUsStep2";
import Agreement from "./Agreement";
import Mall from "./Mall";
import MyDelian from "./MyDelian";
import Cartlist from "./Cartlist";
import Confirmorder from "./Confirmorder";
import OrderDetail from "./OrderDetail";
import InvoiceManagement from "./InvoiceManagement";
import MyPoint from "./MyPoint";
import ContactManagement from "./ContactManagement";
import AddressManagement from "./AddressManagement";
import MallList from "./MallList";
import Product from "./Product";

import Login from "./Login";
const routes = [
    { path: '/delianacnew/', component: <HomeOne /> },
    { path: '/reactweb/', component: <HomeOne /> },
    { path: '', component: <HomeOne  /> },
    { path: '/', component: <HomeOne /> },
    { path: '/home', component: <HomeOne /> },
    { path: '/AboutUs', component: <AboutUs /> },
    { path: '/FinancialService', component: <FinancialService /> },
    { path: '/IncrementService', component: <IncrementService /> },
    { path: '/ITService', component: <ITService /> },
    { path: '/JoinUs', component: <JoinUs /> },
    { path: '/JoinUsStep', component: <JoinUsStep /> },
    { path: '/JoinUsStep1', component: <JoinUsStep1 /> },
    { path: '/JoinUsStep2', component: <JoinUsStep2 /> },
    { path: '/Mall', component: <Mall /> },
    { path: '/MallList', component: <MallList /> },
    { path: '/Cartlist', component: <Cartlist /> },
    { path: '/Confirmorder', component: <Confirmorder /> },    
    { path: '/Agreement', component: <Agreement /> },
    { path: '/MyDelian', component: <MyDelian /> },
    { path: '/Product', component: <Product /> },
    { path: '/OrderDetail', component: <OrderDetail /> },
    { path: '/InvoiceManagement', component: <InvoiceManagement /> },
    { path: '/MyPoint', component: <MyPoint /> },
    { path: '/ContactManagement', component: <ContactManagement /> },
    { path: '/AddressManagement', component: <AddressManagement /> },
    { path: '/login', component: <Login /> },
]

export default routes;